/** @jsx jsx */
import { jsx } from "@emotion/react";
import styled from "@emotion/styled";
import { graphql } from "gatsby";
import React from "react";
import Seo from "gatsby-plugin-wpgraphql-seo";

import { Query } from "../../gatsby-types";

import Hero from "../components/Hero";
import Layout from "../components/Layout";
import SectionGrey from "../components/SectionGrey";

import { media, Breakpoint, themeColor } from "../theme";

const GenericContainer = styled.div`
  position: relative;
  padding: 40px 20px;
  width: 100%;
  max-width: 335px;
  background: ${themeColor("white")};

  ${media(Breakpoint.Tablet)} {
    padding: 60px 40px;
    max-width: 900px;
  }

  h1 {
    font-size: 30px;
  }

  h2 {
    font-size: 28px;
  }

  h3 {
    font-size: 26px;
  }

  h4 {
    font-size: 24px;
  }

  h5 {
    font-size: 22px;
  }

  h6 {
    font-size: 20px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${themeColor("grey700")};
    letter-spacing: 0.1em;
    line-height: 1.2em;
    text-transform: uppercase;
    margin: 40px auto 20px;
  }

  p,
  ul,
  ol {
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 20px;

    ${media(Breakpoint.Tablet)} {
      font-size: 18px;
      line-height: 26px;
    }
  }

  ul,
  ol {
    margin-left: 20px;

    li {
      margin-bottom: 10px;
    }
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }

  hr {
    border: 0;
    background: ${themeColor("grey100")};
    height: 1px;
    width: 100%;
    margin: 20px auto;
  }
`;

type PropsType = {
  data: Query;
};

const Generic: React.FC<PropsType> = (props) => {
  if (!props.data.wpPage) {
    return null;
  }

  return (
    <Layout darkHeader>
      <Seo post={props.data.wpPage} />
      <Hero page="generic" header={props.data.wpPage.title || ""} />
      <SectionGrey>
        <GenericContainer
          css={{ margin: "0 auto", [media(Breakpoint.DesktopLarge)]: { marginTop: "-100px" } }}
          dangerouslySetInnerHTML={{ __html: props.data.wpPage.content || "" }}
        />
      </SectionGrey>
    </Layout>
  );
};

export const pageQuery = graphql`
  query GenericPage($wpId: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    wpPage(id: { eq: $wpId }) {
      id
      title
      nodeType
      uri
      content
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
  }
`;

export default Generic;
